// ------------- import external dependencies  -------------
import { useMutation } from "@tanstack/react-query";

// ------------ import internal dependencies --------------
import {
  resetPassword,
  createPassword,
  forgotPassword,
  requestPasswordResetToken,
  changeLoggedInUserPassword,
} from "../../../api/auth";

import {
  login,
  changePassword,
  requestPasswordReset as requestDotNetReset,
  setUserPassword,
} from "../../../api/authApi";

function useAuth() {
  /**
   * Handle MRC user login
   */

  const mrcLogin = useMutation((req: any) => login(req));

  /**
   * User reset password via email
   */
  const resetUserPassword = useMutation((req: any) => resetPassword(req));

  const newPassword = useMutation((req: any) => createPassword(req));

  const doChangeLoggedInUserPassword = useMutation((req: any) =>
    changeLoggedInUserPassword(req)
  );

  const forgotUserPassword = useMutation((req: any) => forgotPassword(req));

  const changeDotNetPassword = useMutation((req: any) => changePassword(req));

  const requestDotNetPasswordReset = useMutation((req: any) => requestDotNetReset(req));

  const requestPasswordReset = useMutation((req: any) =>
    requestPasswordResetToken(req)
  );

  const resetPasswordForUser = useMutation((req: any) => setUserPassword(req));

  return {
    mrcLogin,
    changeDotNetPassword,
    requestDotNetPasswordReset,
    resetUserPassword,
    newPassword,
    forgotUserPassword,
    requestPasswordReset,
    resetPasswordForUser,
    doChangeLoggedInUserPassword,
  };
}

export default useAuth;
